var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC2CNight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3958,
    cy: 8.89776,
    r: 2.40753,
    fill: "#F2F6F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.431,
    cy: 19.4339,
    r: 2.40753,
    fill: "#F2F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9924 20.1213V16.5235C14.9924 14.5365 13.3816 12.9258 11.3946 12.9258V12.9258C9.40764 12.9258 7.79688 14.5365 7.79688 16.5235V20.1213",
    stroke: "#F2F6F9",
    strokeWidth: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0314 30.6584V27.0606C28.0314 25.0737 26.4207 23.4629 24.4337 23.4629V23.4629C22.4467 23.4629 20.8359 25.0737 20.8359 27.0606V30.6584",
    stroke: "#F2F6F9",
    strokeWidth: 2.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0336 13.975V8.72266H22.7812",
    stroke: "#863DFF",
    strokeWidth: 2.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5273 8.7226L24.2078 6.48926V10.9559L20.5273 8.7226Z",
    fill: "#863DFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79449 23.1714V28.4238H13.0469",
    stroke: "#863DFF",
    strokeWidth: 2.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3047 28.4249L11.6243 30.6582V26.1915L15.3047 28.4249Z",
    fill: "#863DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2CNight);
export default __webpack_public_path__ + "static/media/C2C_night.b8b62ee3dd75e4532e3858a0c6241448.svg";
export { ForwardRef as ReactComponent };